<template>
  <!-- MENU CONTAINER SECTION BACKGROUND -->
  <div class="menu_container_section_background">
    <!-- MENU CONTAINER SECTION CONTAINER -->
    <div class="col-md-12 menu_container_section_container" >
      <div class="menu_container_section_" @click="setRouter('turmas')">
        <figure class="menu_container_section_img">
          <img src="img/turmasAdd.png" />
        </figure>
        <div class="menu_container_section_text_container">
          <span class="menu_container_section_text_title">Novo Estudante</span>
        </div>
      </div>   


      <div class="menu_container_section_" @click="setRouter('funcionario/cadastrar')">
        <figure class="menu_container_section_img">
          <img src="img/funcionario.png" />
        </figure>
        <div class="menu_container_section_text_container">
          <span class="menu_container_section_text_title">Novo Funcionário</span>
        </div>
      </div>   

      <div class="menu_container_section_"  @click="setRouter('funcionario/listagem')">
        <figure class="menu_container_section_img">
          <img src="img/listarDados.png" />
        </figure>
        <div class="menu_container_section_text_container">
          <span class="menu_container_section_text_title">Listagem de Funcionários</span>
        </div>
      </div>   

 
       <div class="menu_container_section_"  @click="setRouter('professor/atribuir-turmas')">
        <figure class="menu_container_section_img">
          <img src="img/boletims.png" />
        </figure>
        <div class="menu_container_section_text_container">
          <span class="menu_container_section_text_title">Atribuição de  Turmas Professor</span>
        </div>
      </div>      

       <div class="menu_container_section_"  @click="setRouter('professor/listagem')">
        <figure class="menu_container_section_img">
          <img src="img/listarProfessores.png" />
        </figure>
        <div class="menu_container_section_text_container">
          <span class="menu_container_section_text_title">Listagem de professores</span>
        </div>
      </div>   

        
      
    </div>
    <!-- FIM MENU CONTAINER SECTION CONTAINER -->
  </div>
  <!-- FIM MENU CONTAINER SECTION BACKGROUND -->
</template>
<script>
import Swal from 'sweetalert2'
export default {
     
     data: ()=>({

     }),
       created(){
      this.$store.state.idclasse = null
     },
     methods: {
        
           setRouter(router){
            this.$store.state.fromMenu = 'gestao'
            this.$router.push(router)
           },

           IndisponivelMomento (){
             Swal.fire('Informação','Funcionalidade indisponível de momento.','warning')
           }

     }

}
</script>

